// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { FEATURES } from './config/features';
import { RiderProvider, useRider } from './context/RiderContext';
import { LanguageProvider } from './i18n/LanguageContext';
import { initNativePhoneAuth } from './services/firebase';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ActiveRide from './pages/ActiveRide';
import Earnings from './pages/Earnings';
import Profile from './pages/Profile';
import ActiveDelivery from './pages/ActiveDelivery';


const AppRoutes = () => {
  const { rider, authLoading } = useRider();
  if (authLoading) return (
    <div style={{ maxWidth: 420, margin: '0 auto', minHeight: '100vh', background: 'var(--black)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 16 }}>
      <div style={{ fontSize: 48 }}>{FEATURES.RIDES_ENABLED ? '🛺' : '📦'}</div>
      <div style={{ color: 'var(--green)', fontWeight: 800, fontSize: 20 }}>MyTownly {FEATURES.RIDES_ENABLED ? 'Rider' : 'Delivery'}</div>
      <div className="spinner" />
    </div>
  );
  return (
    <Routes>
<Route path="/active-delivery" element={rider ? <ActiveDelivery /> : <Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
      <Route path="/" element={rider ? <Dashboard /> : <Navigate to="/login" />} />
      <Route path="/active-ride" element={FEATURES.RIDES_ENABLED && rider ? <ActiveRide /> : <Navigate to="/" />} />
      <Route path="/earnings" element={<Navigate to="/history" replace />} />
      <Route path="/history" element={rider ? <Earnings /> : <Navigate to="/login" />} />
      <Route path="/profile" element={rider ? <Profile /> : <Navigate to="/login" />} />
      <Route path="/onboard" element={rider ? <Login /> : <Navigate to="/login" />} />
    </Routes>
  );
};

export default function App() {
  useEffect(() => { initNativePhoneAuth(); }, []);

  return (
    <LanguageProvider>
      <RiderProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-center" toastOptions={{
            style: { fontFamily: 'DM Sans, sans-serif', fontSize: 14, borderRadius: 12, background: '#1a1d24', color: '#e5e7eb', border: '1px solid #2a2d35' },
            success: { iconTheme: { primary: '#00d68f', secondary: '#0a0a0a' } },
          }} />
        </BrowserRouter>
      </RiderProvider>
    </LanguageProvider>
  );
}
